
import React, { useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Carousel from './components/Carousel';
import Stats from './components/Stats';
import FeatureBlock from './components/FeatureBlock';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';

export type Language = 'pt' | 'en';

const App: React.FC = () => {
  const [lang, setLang] = useState<Language>('pt');

  const content = {
    pt: {
      features: [
        {
          title: "Onboarding Sem Fricção",
          text: "Transformamos a complexidade da Web3 em um fluxo simples. Usuários adquirem seu token instantaneamente com PIX.",
          bullets: ["Wallet assistida por Smart Account", "Gateway de PIX nativo", "Entrega imediata via Smart Contract"]
        },
        {
          title: "Infraestrutura Pré-Venda",
          text: "Logística completa de distribuição automatizada. Gerencie sua venda sem precisar desenvolver uma única linha de código.",
          bullets: ["Distribuição via pools privados", "Checkout Web2 experience", "Vesting e locks programáveis"]
        },
        {
          title: "Ecossistema de Marketing",
          text: "Sua listagem é acompanhada por visibilidade real. Colocamos seu projeto na frente de milhares de usuários qualificados.",
          bullets: ["Notícias internas push-enabled", "Banners em pontos de alta conversão", "Upvote gamificado pela comunidade"]
        },
        {
          title: "Liquidez e Engajamento",
          text: "Estimulamos a movimentação constante do seu token através de incentivos diretos e prova social integrada.",
          bullets: ["Campanhas de Swap Rewards", "Proof-of-Buy automático no Telegram", "Ranking dinâmico por volume real"]
        }
      ]
    },
    en: {
      features: [
        {
          title: "Frictionless Onboarding",
          text: "We transform Web3 complexity into a simple flow. Users acquire your token instantly with local payments.",
          bullets: ["Smart Account assisted Wallet", "Native Fiat Gateway", "Immediate Smart Contract delivery"]
        },
        {
          title: "Pre-Sale Infrastructure",
          text: "Complete automated distribution logistics. Manage your sale without writing a single line of code.",
          bullets: ["Private pool distribution", "Web2 checkout experience", "Programmable vesting and locks"]
        },
        {
          title: "Marketing Ecosystem",
          text: "Your listing is accompanied by real visibility. We put your project in front of thousands of qualified users.",
          bullets: ["Push-enabled internal news", "High-conversion banner spots", "Community-led gamified upvote"]
        },
        {
          title: "Liquidity and Engagement",
          text: "We stimulate constant movement of your token through direct incentives and integrated social proof.",
          bullets: ["Swap Rewards campaigns", "Automatic Proof-of-Buy on Telegram", "Real volume-based dynamic ranking"]
        }
      ]
    }
  };

  return (
    <div className="min-h-screen bg-black text-white selection:bg-orange-500/30 selection:text-orange-400">
      <Navbar lang={lang} setLang={setLang} />
      
      <main>
        <Hero lang={lang} />
        <Carousel lang={lang} />
        <Stats lang={lang} />

        {content[lang].features.map((f, i) => (
          <FeatureBlock 
            key={i}
            title={f.title}
            text={f.text}
            bullets={f.bullets}
            image="" 
          />
        ))}

        <FinalCTA lang={lang} />
      </main>

      <Footer lang={lang} />
    </div>
  );
}

export default App;
